
export default {
  'index.hero.title': 'Welcome to Pink Paradise',
  'index.hero.subtitle': 'The premium platform connecting sophisticated individuals with elite escorts and exclusive content, all in a safe space.',
  'index.hero.join_now': 'Join Now',
  'index.hero.explore': 'Explore',
  'index.features.title': 'The Ultimate Premium Experience',
  'index.features.subtitle': 'Pink Paradise offers a unique combination of real-life encounters and exclusive content',
  'index.features.privacy.title': 'Privacy & Security',
  'index.features.privacy.description': 'Industry-leading security measures, including anonymous access options and complete discretion.',
  'index.features.content.title': 'Exclusive Content',
  'index.features.content.description': 'Access premium photos, videos, and custom content available only to subscribers.',
  'index.features.messaging.title': 'Secure Messaging',
  'index.features.messaging.description': 'Private, encrypted communication between clients and escorts to arrange meetings.',
  'index.subscription.title': 'Choose Your Experience',
  'index.subscription.subtitle': 'Select the perfect membership tier to match your desires',
  'index.subscription.basic.title': 'Pink Teaser',
  'index.subscription.basic.price': '€4.99',
  'index.subscription.basic.period': '/month',
  'index.subscription.basic.feature1': 'No ads',
  'index.subscription.basic.feature2': 'Access to teaser private content',
  'index.subscription.basic.feature3': 'Basic messaging access',
  'index.subscription.basic.cta': 'Get Started',
  'index.subscription.regular.title': 'Pink Regular',
  'index.subscription.regular.price': '€19.99',
  'index.subscription.regular.period': '/month',
  'index.subscription.regular.feature1': 'Client verification included',
  'index.subscription.regular.feature2': 'Full access to all photos and videos',
  'index.subscription.regular.feature3': 'Leave reviews after encounters',
  'index.subscription.regular.cta': 'Subscribe Now',
  'index.subscription.vip.title': 'Pink VIP',
  'index.subscription.vip.price': '€99.99',
  'index.subscription.vip.period': '/month',
  'index.subscription.vip.feature1': 'VIP badge on profile and messages',
  'index.subscription.vip.feature2': 'Early access to new escorts',
  'index.subscription.vip.feature3': 'Access to VIP-only escorts',
  'index.subscription.vip.cta': 'Go VIP',
  'index.subscription.more_info': 'View detailed subscription info',
  'index.cta.title': 'Ready to experience Pink Paradise?',
  'index.cta.subtitle': 'Join our exclusive community today and discover a world of premium connections and content.',
  'index.cta.create_account': 'Create Account',
  'index.cta.explore_profiles': 'Explore Profiles',
};
